import { TFunction } from 'i18next';

import { CARD_IDS } from '@/components/AdvertisePayments/components/ExtraContent/ExtraContent.types';
import {
  CARD_VARIANT_THEME_KEYS,
  CardVariantThemeKey,
  ContentOptions,
  OptionCardStyle
} from '@/components/AdvertisePayments/components/Options/Options.types';

export const getPremiumOptions = (t: TFunction): ContentOptions => [
  {
    id: 1,
    title: t('Advertise.premiumFeatures.home_page_display'),
    description: t('Advertise.premiumFeatures.home_page_display_desc')
  },
  {
    id: 2,
    title: t('Advertise.premiumFeatures.highlight_badge'),
    description: t('Advertise.premiumFeatures.highlight_badge_desc')
  },
  {
    id: 3,
    title: t('Advertise.premiumFeatures.top_listing'),
    description: t('Advertise.premiumFeatures.top_listing_desc')
  },
  {
    id: 4,
    title: t('Advertise.premiumFeatures.more_views'),
    description: t('Advertise.premiumFeatures.premium_effect')
  }
];

export const getTopOptions = (t: TFunction): ContentOptions => [
  {
    id: 1,
    title: t('Advertise.topListingFeatures.top_position'),
    description: t('Advertise.topListingFeatures.top_position_desc')
  },
  {
    id: 2,
    title: t('Advertise.topListingFeatures.more_views'),
    description: t('Advertise.topListingFeatures.more_views_desc')
  }
];

export const optionCardStyleMap: Record<CardVariantThemeKey, OptionCardStyle> =
  {
    [CARD_VARIANT_THEME_KEYS.ACTIVE_LIGHT_TOP]: {
      background: 'var(--textAndLabels-bump)',
      borderColor: 'var(--textAndLabels-main)',
      iconBackground: 'var(--system-brand)'
    },
    [CARD_VARIANT_THEME_KEYS.INACTIVE_LIGHT_TOP]: {
      background: 'var(--bg-secondary)',
      borderColor: 'transparent'
    },
    [CARD_VARIANT_THEME_KEYS.ACTIVE_LIGHT_PREMIUM]: {
      background: 'var(--textAndLabels-premium)',
      borderColor: 'var(--bg-premium)',
      iconBackground: 'var(--bg-premium)'
    },
    [CARD_VARIANT_THEME_KEYS.INACTIVE_LIGHT_PREMIUM]: {
      background: 'var(--bg-secondary)',
      borderColor: 'transparent'
    },
    [CARD_VARIANT_THEME_KEYS.ACTIVE_DARK_TOP]: {
      background: 'var(--textAndLabels-bump)',
      borderColor: 'var(--border-primary)',
      iconBackground: 'var(--brand-main)'
    },
    [CARD_VARIANT_THEME_KEYS.INACTIVE_DARK_TOP]: {
      background: 'var(--bg-secondary)',
      borderColor: 'transparent'
    },
    [CARD_VARIANT_THEME_KEYS.ACTIVE_DARK_PREMIUM]: {
      background: 'var(--textAndLabels-premium)',
      borderColor: 'var(--bg-premium)',
      iconBackground: 'var(--bg-premium)'
    },
    [CARD_VARIANT_THEME_KEYS.INACTIVE_DARK_PREMIUM]: {
      background: 'var(--bg-secondary)',
      borderColor: 'transparent'
    }
  };

export const fallbackCardStyle: OptionCardStyle = {
  background: 'var(--bg-secondary)',
  borderColor: 'transparent'
};

export const getOptionCardStyle = (
  isActive: boolean,
  isDark: boolean,
  cardId: string
): OptionCardStyle => {
  const variant = isActive ? 'ACTIVE' : 'INACTIVE';
  const theme = isDark ? 'DARK' : 'LIGHT';
  const normalizedCardId = cardId === CARD_IDS.TOP ? 'TOP' : 'PREMIUM';

  const key = `${variant}_${theme}_${normalizedCardId}` as CardVariantThemeKey;

  return optionCardStyleMap[key] ?? fallbackCardStyle;
};
